<template>
    <empresa></empresa>
</template>

<script>

import Empresa from '../Empresa.vue'

export default {
    components: {
        'empresa': Empresa
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PaginaEmpresa.vue